import { HelmetProvider } from 'react-helmet-async';

import { InitLoader, UniversalLoader } from '@willow/shared-web';

import { FindPortalPage } from './FindPortalPage';

const renderLoader = (isLoading: boolean) => <InitLoader visible={isLoading} />;

export const FindPortalApp = () => (
  <HelmetProvider>
    <UniversalLoader loader={renderLoader}>
      <FindPortalPage />
    </UniversalLoader>
  </HelmetProvider>
);
